<template>
    <div class="energyranking">
        <Title firstName="负荷排名" lastName="ENERGY CONSUMPTION RANKING"/>
        <div class="content">
            <div class="type">
                <span>馈线</span><span></span>
                <span>进线</span><span></span>
            </div>
            <div class="energy">
                <div class="energyitem" v-for="item in energyList" :key="item.serial" >
                    <div class="serial">{{item.serial}}</div>
                    <div class="name">
                        <div class="nametop">
                            <div class="namebox">{{item.name}}</div>
                            <div class="sum">{{item.sum}} <span>kVA</span></div>
                        </div>
                        <el-progress :percentage="item.percentage" :stroke-width="3" :color="item.type== 'IN' ?'#FF9D4D' :'#6DC8EC'" :show-text="false" ></el-progress>
                    </div>
                </div>
            </div>
            <div class="bottom"></div>
        </div>
    </div>
</template>

<script>
const Title = () => import('../../../../components/title/Title')
export default {
    data(){
        return {
            energyList:[
                {
                    serial:1,
                    type:'IN',
                    name:'T1总进线',
                    sum:'163.04',
                    percentage:100
                },
                {
                    serial:2,
                    type:'IN',
                    name:'T1总进线',
                    sum:'163.04',
                    percentage:70
                },
                {
                    serial:3,
                    type:'IN',
                    name:'T1总进线',
                    sum:'163.04',
                    percentage:50
                },
                {
                    serial:4,
                    type:'OUT',
                    name:'T1总进线',
                    sum:'163.04',
                    percentage:40
                },
                {
                    serial:5,
                    type:'OUT',
                    name:'T1总进线',
                    sum:'163.04',
                    percentage:30
                },
                {
                    serial:6,
                    type:'OUT',
                    name:'T1总进线',
                    sum:'163.04',
                    percentage:20
                },
            ]
        }
    },
    watch: {
    },
    components:{
        Title,
    },
    mounted(){
    },
    methods:{
    }
}
</script>

<style lang="less" scoped>
    .energyranking{
        height: 33.3vh;
        width: 20vw;
        position: fixed;
        top: 7.4vh;
        right: 1vw;
        z-index: 1;

        .content{
            position: relative;
            height: 25vh;
            padding:0 15rem 1vh 15rem;
            background:  linear-gradient(0deg, rgba(0, 33, 59, 0.6) 0%, rgba(3, 13, 24, 0.7) 100%);
            
            .type{
                height:40rem ;
                line-height: 40rem;
                display: flex;
                flex-direction: row-reverse;
                align-items: center;
                justify-content: right;
                &>span:nth-child(even){
                    width: 10rem ;
                    height: 10rem;
                    background-color: #fff;
                    vertical-align: middle;
                    margin-right: 7rem;
                }
                &>span:nth-child(odd){
                    font-size: 14rem;
                    font-family: Source Han Sans CN;
                    font-weight: 400;
                    color: rgba(255, 255, 255, 0.7);
                    margin-right: 15rem;
                }
                &>span:nth-child(2){
                    background-color: #6DC8EC;
                }
                &>span:nth-child(1){
                    margin-right: 2rem;
                }
                &>span:nth-child(4){
                    background-color: #FF9D4D;
                }
            }

            .energy{
                width: 100%;
                height: calc(23vh - 40rem);
                overflow-x:hidden ;
                overflow-y: scroll;

                .energyitem{
                    height: 38rem;
                    display: flex;
                    align-items: center;
                    .serial{
                        width: 28rem;
                        height: 28rem;
                        border-radius: 50%;
                        border: 2px solid #00ABE7;
                        background: rgba(0, 106, 220, 0.2);
                        line-height: 24rem;
                        text-align: center;
                        margin-right:10rem ;
                        color:rgba(230,243,253, 0.7) ;
                    }
                    .name{
                        width:calc(100% - 38rem);
                        .nametop{
                            height: 24rem;
                            display: flex;
                            justify-content: space-between;
                            .namebox{
                                font-size: 14rem;
                                font-family: Source Han Sans CN;
                                font-weight: 400;
                                color:rgba(230,243,253, 0.7) ;
                            }
                            .sum{
                                font-size: 20rem;
                                font-family: zcoolqingkehuangyouti;
                                font-weight: 400;
                                color: #00DEFF;
                                span{
                                    font-size: 14rem;
                                }
                            }
                        }
                        

                    }
                    ::v-deep.el-progress-bar__outer{
                            background-color: rgba(0, 0, 0, 0);
                        }
                }
            }
            .energy::-webkit-scrollbar{
                display: none;
            }
            // .energy::-webkit-scrollbar-thumb{
            //     display: none;
            // }

            .bottom{
                width: 20vw;
                height: 1vh;
                background: url(../../../../assets/img/板块装饰线.png) no-repeat;
                block-size: 100% 100%;
                position: absolute;
                bottom: 0;
                left: 0;
            }
        }

        
    }

</style>